import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { TextButton, useMediaQuery } from 'bonfire-kindling';

import { ConfirmationModal } from 'components';
import { useOpportunities } from '../../OpportunitiesProvider';

const SaveCurrentSearchButton = ({ tab }) => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const isMobile = useMediaQuery(theme => theme.breakpoints.down('sm'));
  const { isSearchingOrFiltering, onSaveCurrentSearchProfile } = useOpportunities();

  return (
    <>
      <TextButton
        onClick={() => {
          if (tab === 'saved') {
            setOpen(true);
          } else {
            onSaveCurrentSearchProfile('new');
          }
        }}
        variant="contained"
        label={t('opportunities.filters.save_current_search')}
        sx={{ mb: { xs: 3, sm: 0 } }}
        fullWidth={isMobile}
        disabled={!isSearchingOrFiltering}
      />
      <ConfirmationModal
        open={open}
        title={t('opportunities.filters.override_saved_search')}
        onClose={() => setOpen(false)}
        CancelButtonProps={{
          label: t('opportunities.filters.override_saved_search_create'),
          onClick: () => onSaveCurrentSearchProfile('new'),
        }}
        ConfirmButtonProps={{
          label: t('opportunities.filters.override_saved_search_override'),
          onClick: () => onSaveCurrentSearchProfile('override'),
        }}
      />
    </>
  );
};

export default SaveCurrentSearchButton;
